import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { useBreakdownStaleRegistry } from "../../../../BookingForm/components/Commercial/add-plan/useBreakdownStaleRegistry";
import { useBookingSelector } from "../../../../BookingForm/hooks/useBookingSelector";
import type { PaymentPlansStepFormValues } from "./types";

type UsePaymentPlansStaleRegistryProps = {
  isSeparateInvoicingEnabled: boolean;
  yearLimit: number;
  isTurnoverRentOnly: boolean;
  isleaseTypeTor: boolean;
};

export const usePaymentPlansStaleRegistry = (props: UsePaymentPlansStaleRegistryProps) => {
  const { isSeparateInvoicingEnabled, yearLimit, isTurnoverRentOnly, isleaseTypeTor } = props;
  const bookingDetails = useBookingSelector();

  const {
    control,
    formState: { isDirty },
  } = useFormContext<PaymentPlansStepFormValues>();

  const { fields: plansFields } = useFieldArray({ control, name: "plans" });

  const plansWatch = useWatch({ control, name: "plans" });

  const { registerPaymentPlanBreakdownStale, registerServiceChargeBreakdownStale, assertNoStaleCommercialBreakdowns } =
    useBreakdownStaleRegistry({
      plansFields,
      isSeparateInvoicingEnabled,
      plansWatch,
      savedPaymentPlan: bookingDetails?.paymentPlan,
      savedCommercialBreakdown: bookingDetails?.commercialBillingScheduleBreakdown,
      isDirty,
      yearDifference: yearLimit,
      isTurnoverRentOnly,
      requiresTorPeriod: isleaseTypeTor,
      paymentPlanApproval: bookingDetails?.paymentPlanApproval,
    });

  return {
    registerPaymentPlanBreakdownStale,
    registerServiceChargeBreakdownStale,
    assertNoStaleCommercialBreakdowns,
  };
};
